import { FatInvestorsPageListEntitiesQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import { TenantType } from '@trace-8/trace8-schema';
import styled from 'styled-components';

interface TableBodyEntityProps {
  listEntity: FatInvestorsPageListEntitiesQuery['listEntities']['data'];
  columns: TableColumns[];
  openInvestorDetailsPage: ({ investorId, entityId, isGroup }: { investorId: string; entityId?: string; isGroup?: boolean }) => Promise<void>;
}

const TableBodyEntity = ({ listEntity, columns, openInvestorDetailsPage }: TableBodyEntityProps) => {
  const { user } = useAuth();

  if (!listEntity?.length) {
    return <NoResults />;
  }

  return (
    <>
      {listEntity.map((row) => (
        <CustomTableRowWrapper key={row.id}>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell
              id="actionCurioText"
              onClick={() => openInvestorDetailsPage({ investorId: row.family.id, entityId: row.id, isGroup: row.isGroup })}
            >
              {row.entityName}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openInvestorDetailsPage({ investorId: row.family.id })}>
              {row.family.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            {user && user.tenant.type === TenantType.PLATFORM_MANAGER && <TextCell>{row.tenant.name}</TextCell>}
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>{row.investmentCount}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <TextCell>{row.ignoreAllocationTargets ? <>--</> : <FormattingTooltip>{row.totalEntityValue}</FormattingTooltip>}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[5].width}>
            <TextCell>
              <FormattingTooltip>{row.totalCommitments}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TableBodyEntity;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;
